var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Section',{attrs:{"options":_vm.sectionOptions}},_vm._l((_vm.members),function(group,index){return _c('GroupComponent',{key:index + '-group',attrs:{"options":_vm.getGroupOptions(group),"labels":_vm.getGroupLabels(group)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }